import r from "./ghl-ui.es719.js";
import t from "./ghl-ui.es720.js";
function m() {
  return r(t, arguments);
}
export {
  m as parsePhoneNumberWithError
};
